import { useEffect, useState } from "react";
import { TableItem } from "./TableItem";
import api, { schedulesApi } from "../../../../services/api";
import { StyledInProgressAttendances } from "./style";
import { ScheduledAttendanceDetails } from "../../../../interfaces/Attendances.interfaces";
import Input from "../../../../components/Input";
import { defaultInput100, defaultSelect100 } from "../../../../components-variants/defaultInputs";
import MultiSelect from "../../../../components/MultiSelect";
import { currentRoute } from "../../../../contexts/global/LoginContext";
import { CustomState } from "../../../../Hooks/State.hook";

export const AppointmentsSchedules = () => {
    const schedules = CustomState<ScheduledAttendanceDetails[]>([]);
    const filteredSchedules = CustomState<ScheduledAttendanceDetails[]>([]);
    const toOperators = Array.from(new Set(schedules.value.map(s => s.toUserName)));
    const byOperators = Array.from(new Set(schedules.value.map(s => s.byUserName)));

    const [updater, setUpdater] = useState(0);

    const update = () => setUpdater(prev => prev + 1);

    useEffect(() => {
        schedulesApi.get<{ message: string, data: Array<ScheduledAttendanceDetails> }>("")
            .then((res) => schedules.set(res.data.data))
    }, [updater]);

    const filters = CustomState({
        id: "",
        byUserName: [] as string[],
        toUserName: [] as string[],
        sectorName: [] as string[],
        contactName: "",
        customerName: "",
        contactNumber: "",
    });

    useEffect(() => {
        filteredSchedules.set(schedules.value.filter((s) => {
            const { id, byUserName, toUserName, contactName, contactNumber, customerName, sectorName } = filters.value;
            const conditions = [
                !id || s.id.includes(id),
                !byUserName.length || byUserName.some(v => s.byUserName === v),
                !toUserName.length || toUserName.some(v => s.toUserName === v),
                !sectorName.length || sectorName.some(v => s.sectorName === v),
                !customerName || s.customerName.toLowerCase().includes(customerName.toLowerCase()),
                !contactName || s.contactName.toLowerCase().includes(contactName.toLowerCase()),
                !contactNumber || s.contactNumber.includes(contactNumber.replace(/\D/g, "")),
            ];

            return conditions.every(v => !!v);
        }));
    }, [schedules.value, filters.value]);

    return (
        <StyledInProgressAttendances>
            <header>
                <div className="actions">
                    Ações
                </div>
                <div className="id search">
                    <Input
                        placeholder="ID"
                        value={filters.value.id}
                        onChange={(e) => filters.set(v => ({ ...v, id: e.target.value }))}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="contact search">
                    <Input
                        placeholder="Contato"
                        value={filters.value.contactName}
                        onChange={(e) => filters.set(v => ({ ...v, contactName: e.target.value }))}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="phone search">
                    <Input
                        placeholder="Numero"
                        value={filters.value.contactNumber}
                        onChange={(e) => filters.set(v => ({ ...v, contactNumber: e.target.value }))}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="customer search">
                    <Input
                        placeholder="Razão Social"
                        value={filters.value.customerName}
                        onChange={(e) => filters.set(v => ({ ...v, customerName: e.target.value }))}
                        {...defaultInput100}
                        $disableBorder
                        $fontSize={0.75}
                    />
                </div>
                <div className="by_user search">
                    <MultiSelect
                        options={byOperators.map(o => ({ name: o, value: o, key: o }))}
                        onChange={(e) => filters.set(v => ({ ...v, byUserName: e }))}
                        placeholder="Agendado por"
                        $disableBorder
                        {...defaultSelect100}
                        $fontSize={0.75}
                    />
                </div>
                <div className="to_user search">
                    <MultiSelect
                        options={toOperators.map(o => ({ name: o, value: o, key: o }))}
                        onChange={(e) => filters.set(v => ({ ...v, toUserName: e }))}
                        placeholder="Agendado para"
                        $disableBorder
                        {...defaultSelect100}
                        $fontSize={0.75}
                    />
                </div>
                <div className="s_date">
                    Agendamento
                </div>
            </header>
            <div>
                {
                    filteredSchedules.value.map((s, i) => <TableItem schedule={s} key={i} update={update} />)
                }
            </div>
        </StyledInProgressAttendances>
    );
};